module.exports = __webpack_public_path__ + "img/price-promise-right.dac6ec8.svg";